import { memo } from "react";
import { cn } from "@/components/ui/utils";
import { waveformLevels } from "@/lib/voice/audio-level";

const DEFAULT_BAR_COUNT = 28;
const MINIMUM_BAR_PERCENT = 12;

interface VoiceWaveformProps {
  className?: string;
  levels: readonly number[];
  muted?: boolean;
}

/** A compact history of real microphone or playback levels; silence stays flat. */
export const VoiceWaveform = memo(function VoiceWaveform({
  className,
  levels,
  muted = false,
}: VoiceWaveformProps) {
  const bars = waveformLevels(muted ? [] : levels, DEFAULT_BAR_COUNT);

  return (
    <div
      aria-hidden="true"
      className={cn("flex h-8 min-w-0 flex-1 items-center justify-center gap-0.5", className)}
      data-slot="voice-waveform"
    >
      {bars.map((level, index) => (
        <span
          className="h-full w-0.5 min-w-0.5 origin-center rounded-full bg-primary/70 transition-[transform,opacity] [transition-duration:var(--dur-fast)] [transition-timing-function:var(--ease-out)] motion-reduce:transition-none"
          // The fixed bar positions intentionally use their index as identity;
          // only their measured audio scale changes between renders.
          key={index}
          style={{
            opacity: 0.3 + level * 0.7,
            transform: `scaleY(${(MINIMUM_BAR_PERCENT + level * (100 - MINIMUM_BAR_PERCENT)) / 100})`,
          }}
        />
      ))}
    </div>
  );
});
